<template>
  <div class="row">
    <!-- Top Bar -->
    <div class="top-bar">
      <div><p>Tutorial screen</p></div>
      <burger/>
    </div>

    <!-- Main Content -->
    <div class="container-main">
      <div class="container-fluid right-container tutorial-container" id="items-container">
        <div class="col-md-10 offset-md-1">
          <carousel :navigationEnabled="true" :centerMode="true" paginationColor="#777777" paginationActiveColor="#ffffff" style="height: 60vh; padding: 0 60px; margin-top: 70px; text-align: center;" :perPage="1">
            <slide style=" width: 100%;">
              <img src=".././assets/images/screenshot.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Tutorial</h1>
              <p style="text-align: center">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto tempore quaerat reprehenderit debitis, odio dignissimos illo molestiae soluta ad recusandae minima? Eum quos omnis adipisci, del</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/screenshot.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Tutorial</h1>
              <p style="text-align: center">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto tempore quaerat reprehenderit debitis, odio dignissimos illo molestiae soluta ad recusandae minima? Eum quos omnis adipisci, del</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/screenshot.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Tutorial</h1>
              <p style="text-align: center">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto tempore quaerat reprehenderit debitis, odio dignissimos illo molestiae soluta ad recusandae minima? Eum quos omnis adipisci, del</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/screenshot.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Tutorial</h1>
              <p style="text-align: center">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto tempore quaerat reprehenderit debitis, odio dignissimos illo molestiae soluta ad recusandae minima? Eum quos omnis adipisci, del</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/screenshot.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Tutorial</h1>
              <p style="text-align: center">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto tempore quaerat reprehenderit debitis, odio dignissimos illo molestiae soluta ad recusandae minima? Eum quos omnis adipisci, del</p>
            </slide>

            <slide style=" width: 100%;">
              <img src=".././assets/images/screenshot.png" alt="" style="height: 60vh; max-width: 100% !important;">
              <h1 class="text-center">Tutorial</h1>
              <p style="text-align: center">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iusto tempore quaerat reprehenderit debitis, odio dignissimos illo molestiae soluta ad recusandae minima? Eum quos omnis adipisci, del</p>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';
  import Burger from '@/components/Burger';

  export default {
    name: 'Tutorial',
    components: {
      Carousel,
      Slide,
      Burger
    },
    data() {
      return {
        user: null
      };
    },
  };
</script>
